export default "__VITE_ASSET__$URpqQYH__"